<div
  class="visionboard-item-favorite-button-menu"
  *ngIf="isVisible"
>
  <button
    mat-icon-button
    class="visionboard-item-button button-disable-hover-action-style"
    (click)="onFavoriteClick($event)"
    [matTooltip]="tooltipMsg$ | async"
    [color]="buttonColor"
  >
    <ng-container *ngIf="hasFavorites$ | async; else noFavorites">
      <mat-icon svgIcon="favorite"></mat-icon>
    </ng-container>
  </button>
  <span
    #favoriteListMenuTrigger
    class="trigger"
    [matMenuTriggerFor]="menu"
    (menuClosed)="onFavoritesListMenuClose()"
  ></span>
  <mat-menu
    #menu="matMenu"
    yPosition="below"
  >
    <div
      class="visionboard-item-favorite-button-menu-container"
      (click)="$event.stopPropagation()"
    >
      <mat-checkbox
        *ngFor="let list of favoritesLists"
        [checked]="isFavoritesListChecked(list)"
        (change)="onFavoritesCheckboxChange($event, list)"
        >{{ list.listName }}</mat-checkbox
      >
    </div>
  </mat-menu>
</div>

<ng-template #noFavorites>
  <mat-icon svgIcon="favorite_outline"></mat-icon>
</ng-template>
